import { BlobServiceClient } from '@azure/storage-blob'
import { useCallback, useMemo, useState } from 'react'
import { Modal, Button, Form, Collapse, Accordion } from 'react-bootstrap'
import JSONPretty from 'react-json-pretty'
import { CUSTOM_JSON_THEME } from '../../common/common.constants'
import AccordionItem from 'react-bootstrap/esm/AccordionItem'
import AccordionBody from 'react-bootstrap/esm/AccordionBody'
import AccordionHeader from 'react-bootstrap/esm/AccordionHeader'
import { CommonProperties } from '../../common/common.interfaces'
import { notify } from '../../notify/notify'
import { useUserContext } from '../../user/UserContext'
import { apiFetch } from '../../utility/fetch'
import { API_DEV_URL } from '../..'
import { useLoading } from '../../loading/LoadingContext'

interface OrderEditProperties extends CommonProperties {
  modalVisible: boolean
  closeModal: any
  blobName: string
  blobData: any
}

const MAPPING_PATH = 'order-service/mapping'

const OrderEdit = (props: OrderEditProperties) => {
  const {userData} = useUserContext()
  const {toggleLoading, changeStep, changeSubStep} = useLoading()

  if(!props.blobData) return
  const [newData, setNewData] = useState(undefined)
  
  const handleCopyClick = useCallback((e) => {
    const copy = async () => {
      const copyPath = `${MAPPING_PATH}${props.blobName.split('archive')[1]}`
      changeStep('Copying to Sandbox')
      changeSubStep(`Copying production order to sandbox ${copyPath}.`)
      toggleLoading(true)
      
      let copyData = newData ? newData : props.blobData
      if(typeof copyData === 'string'){
        copyData = JSON.parse(copyData)
      }

      const response = await apiFetch({
        endpoint: 'blob',
        method: 'POST',
        accessToken: userData.accessToken,
        baseUrlOverride: API_DEV_URL,
        body: JSON.stringify(copyData),
        params: [
          {key: 'location', value: 'dataservices'},
          {key: 'container', value: 'storage'},
          {key: 'blobname', value: copyPath}
        ]
      })
      if(!response.ok){
        notify('error', `Failed to copy order to sandbox! ${JSON.stringify(response.body)}`)
      } else {
        notify('success', `Copied order to sandbox!`)
      }
      toggleLoading(false)
      
      props.closeModal()
    }
    copy()
  }, [newData])

  const handleDataChanged = useCallback((e) => {
    setNewData(e.target.value)
  }, [])

  const view = useMemo(() => {
    return (
      <Modal show={props.modalVisible} animation={false} onHide={props.closeModal} className='modal-xl'>
        <Modal.Header closeButton>
          <Modal.Title>
            <span className='beacon-header'>Copy Production: {props.blobName} <br/> to Sandbox: {`${MAPPING_PATH}${props.blobName.split('archive')[1]}`}</span>
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Accordion defaultActiveKey={'data'} className='custom-accordion'>
            <AccordionItem eventKey='data'>
              <AccordionHeader><span className='beacon-header'>EDIT ORDER DATA BEFORE SAVING</span></AccordionHeader>
              <AccordionBody>
                <Form.Control onChange={handleDataChanged} spellCheck={false} style={{backgroundColor: 'gray', color: 'white', fontSize: '14px', cursor: 'default'}} as="textarea" rows={20} defaultValue={JSON.stringify(newData ? newData : JSON.parse(props.blobData), null, 2)} />
              </AccordionBody>
            </AccordionItem>
            <AccordionItem eventKey='preview'>
              <AccordionHeader><span className='beacon-header'>PREVIEW DATA</span></AccordionHeader>
              <AccordionBody>
                <JSONPretty data={newData ? newData : props.blobData} theme={CUSTOM_JSON_THEME} style={{fontSize: '1.5em'}} ></JSONPretty>
              </AccordionBody>
            </AccordionItem>
          </Accordion>
        </Modal.Body>

        <Modal.Footer>
          <Button variant='secondary' onClick={handleCopyClick}>Copy to Sandbox</Button>
        </Modal.Footer>
      </Modal>
    )
  }, [newData])

  return view
}

export default OrderEdit
